import { Component, Host, Prop, h } from '@stencil/core';

/** Display component for the inner radio button used in omk-radio. Consumers should not use this directly. */
@Component({
  tag: 'omk-radio-button',
  styleUrl: 'omk-radio-button.scss',
  shadow: true,
})
export class OmkRadioButton {
  @Prop({ reflect: true }) checked: boolean = false;
  @Prop({ reflect: true }) hasFocus: boolean = false;
  @Prop({ reflect: true }) hasHover: boolean = false;
  @Prop({ reflect: true }) hasError: boolean = false;
  @Prop({ reflect: true }) disabled: boolean = false;
  render() {
    return (
      <Host>
        <div class="outer-circle"><div class="inner-circle"></div></div>
      </Host>
    );
  }
}
